import emmaPic from "@/public/images/artists/emma.jpg";
import { Artist } from "@/types/types";

export const emma = {
  id: "301",
  name: "Emma",
  image: emmaPic,
  description: `Emma has a bright voice with a full-bodied tone and a touch of rasp.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Femma-preview.mp3",
  meta: {
    free: true,
    new: true,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Pop", "Folk"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 70,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
